module.exports = __webpack_public_path__ + "static/media/tag_weizhi.58868176.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/product/tag_weizhi.svg
// module id = 740
// module chunks = 0